import { AUTHORITIES } from 'domain/fuse/auth/constants';
import { SHIPPER_STATUS } from 'domain/operations/shippers/constants';

export const isActive = (status) => SHIPPER_STATUS.ACTIVE === status;

export const canChat = (status) => isActive(status);

export const isDeactivated = (status) => SHIPPER_STATUS.PENDING_ACTIVATION === status || SHIPPER_STATUS.SUSPENDED === status;

export const canEdit = (currentId, userId, isBusinessAdmin) => currentId === userId || isBusinessAdmin;

export const getProfilesForRole = (role, profiles) => profiles.filter((profile) => profile.role === role && profile.status === 'ACTIVE');

export const getShipperWithProfiles = (currentShipper) => {
  const shipper = {
    ...currentShipper,
  };
  const { profiles = [] } = shipper;
  const operatorProfiles = getProfilesForRole(AUTHORITIES.OPERATORR, profiles);
  const accountAdminProfiles = getProfilesForRole(AUTHORITIES.ACCOUNT_ADMIN, profiles);
  const financeAdminProfiles = getProfilesForRole(AUTHORITIES.FINANCE_ADMIN, profiles);

  const isOperator = operatorProfiles.length > 0;

  const isAccountAdmin = accountAdminProfiles.length > 0;

  const isFinanceAdmin = financeAdminProfiles.length > 0;

  shipper.isOperator = isOperator;
  shipper.isAccountAdmin = isAccountAdmin;
  shipper.isFinanceAdmin = isFinanceAdmin;

  if (isOperator) {
    shipper.operatorProfileId = operatorProfiles[0].profileId;
  }

  if (isAccountAdmin) {
    shipper.adminProfileId = accountAdminProfiles[0].profileId;
  }

  if (isFinanceAdmin) {
    shipper.financeAdminProfileId = financeAdminProfiles[0].profileId;
  }
  return shipper;
};
